module.exports = __webpack_public_path__ + "images/bc831c64669554501ae7f8acb4f928bd-coffee-cup.png";